import * as React from 'react'

export const SuperscriptIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M15.5129 10.5549V9.05835L19.3398 6.05778C19.6581 5.80711 19.9312 5.57899 20.1593 5.37344C20.3874 5.16287 20.5624 4.95731 20.6844 4.75677C20.8064 4.55122 20.8674 4.32812 20.8674 4.08747C20.8674 3.69642 20.703 3.3906 20.3741 3.17C20.0453 2.94941 19.6422 2.83911 19.1648 2.83911C18.6556 2.83911 18.2445 2.96194 17.9316 3.2076C17.624 3.44825 17.4701 3.78416 17.4701 4.21532H15.3618C15.3618 3.28281 15.7198 2.54833 16.4358 2.01189C17.1572 1.47043 18.0775 1.1997 19.1966 1.1997C19.9551 1.1997 20.6155 1.32754 21.1777 1.58323C21.7453 1.83391 22.1855 2.17482 22.4984 2.60598C22.8114 3.03715 22.9678 3.52095 22.9678 4.05739C22.9678 4.48855 22.875 4.88963 22.6894 5.26063C22.5037 5.62662 22.2147 5.99511 21.8222 6.36611C21.4297 6.73209 20.9284 7.12816 20.3184 7.55431L18.6795 8.78763V8.85531H23.1429V10.5549H15.5129Z'
        fill='currentColor'
      />
      <path
        d='M4.64483 6.05489L7.93072 11.304H8.05802L11.3598 6.05489H15.2504L10.2778 13.7556L15.3618 21.4564H11.3996L8.05802 16.1997H7.93072L4.58913 21.4564H0.642883L5.74278 13.7556L0.738357 6.05489H4.64483Z'
        fill='currentColor'
      />
    </svg>
  )
})

SuperscriptIcon.displayName = 'SuperscriptIcon'
